import {useContext} from "react"
import {InitialDataContext} from "../providers/initial-data-provider"

export const useInitialData = () => useContext(InitialDataContext)
